<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="8" lg="6" xl="5">
            <v-card class="pa-4 pa-md-6">
              <v-img src="/assets/logo.png" max-height="56" contain class="mb-4" />

              <v-alert v-if="globalFlashAlert" type="error" variant="tonal" class="mb-3">
                {{ globalFlashAlert }}
              </v-alert>
              <v-alert v-if="globalFlashNotice" type="success" variant="tonal" class="mb-3">
                {{ globalFlashNotice }}
              </v-alert>

              <h1 class="text-h5 mb-2">{{ pageProps.title }}</h1>
              <p v-if="pageProps.subtitle" class="text-body-2 text-medium-emphasis mb-4">{{ pageProps.subtitle }}</p>

              <v-alert v-if="hasErrors" type="error" variant="tonal" class="mb-4">
                <div class="font-weight-bold mb-2">{{ pageProps.errorsTitle || "Bitte Eingaben prüfen" }}</div>
                <ul class="ma-0 ps-4">
                  <li v-for="error in pageProps.errors" :key="error">{{ error }}</li>
                </ul>
              </v-alert>

              <v-form :method="pageProps.form.method" :action="pageProps.form.action">
                <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
                <input v-if="pageProps.form._method" type="hidden" name="_method" :value="pageProps.form._method">

                <input
                  v-for="hiddenField in pageProps.form.hiddenFields || []"
                  :key="hiddenField.name"
                  type="hidden"
                  :name="hiddenField.name"
                  :value="hiddenField.value"
                >

                <v-row>
                  <v-col
                    v-for="field in pageProps.form.fields || []"
                    :key="field.name"
                    cols="12"
                    :md="field.md || 12"
                  >
                    <v-text-field
                      :name="field.name"
                      :label="field.label"
                      :placeholder="field.placeholder"
                      :type="field.type || 'text'"
                      :autocomplete="field.autocomplete"
                      :model-value="field.value"
                      :required="Boolean(field.required)"
                      :minlength="field.minlength"
                      :maxlength="field.maxlength"
                    />
                  </v-col>
                </v-row>

                <v-btn type="submit" color="primary" block class="mt-1">{{ pageProps.form.submitLabel }}</v-btn>
              </v-form>

              <div v-if="(pageProps.links || []).length > 0" class="mt-4 d-flex flex-column ga-2">
                <a
                  v-for="link in pageProps.links"
                  :key="link.href"
                  :href="link.href"
                  class="text-decoration-none"
                >
                  {{ link.label }}
                </a>
              </div>

              <div class="mt-6 d-flex justify-space-between text-caption">
                <a href="#" class="text-decoration-none">Impressum</a>
                <a href="#" class="text-decoration-none">Datenschutz</a>
                <a href="#" class="text-decoration-none">AGB</a>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { readJsonScript } from "../services/json";

const props = defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});

const globalProps = readJsonScript("vue-global-props", {});

const hasErrors = computed(() => Array.isArray(props.pageProps.errors) && props.pageProps.errors.length > 0);
const globalFlashAlert = computed(() => globalProps.flash?.alert || "");
const globalFlashNotice = computed(() => globalProps.flash?.notice || "");
</script>
